export default __webpack_public_path__ + "static/media/SWT1400.34I-35333_-20478_0.27b24ec8.jpg";